import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { WealthContactSyncSettings } from './WealthContactSyncSettings'

export const WealthSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'sync', label: 'Sync', content: () => <WealthContactSyncSettings /> }]
}
